import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { UserSettings } from '@models/users';

@Injectable()
export class UserSettingService {

  private userSettingsSubject: ReplaySubject<UserSettings> = new ReplaySubject<UserSettings>(1);

  constructor() {
  }

  public addSettings(userSettings: UserSettings) {

    this.userSettingsSubject.next(userSettings);
  
  }

  public getSettings(): Observable<UserSettings> {

    return this.userSettingsSubject.asObservable();
  
  }

}
